import { FC } from 'react';
import { FooterProps } from '../Footer';
import { GettingStartedFooter } from '../../Layouts/GettingStartedLayout/GettingStartedFooter';

export const GettingStartedMealsEveryWeekFooter: FC<FooterProps> = props => (
  <GettingStartedFooter {...props} icon="foodContainer" text="Meals delivered every week" />
);
